import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { Tabs, Tab, Box, Typography, Tooltip } from '@mui/material';
import EmailIcon from '@mui/icons-material/Email';
import PushPinIcon from '@mui/icons-material/PushPin';
import { useSelector } from '../../../redux/store';
import { fNumber } from '../../../utils/formatNumber';

TicketTabs.propTypes = {
  onTabChange: PropTypes.func,
  children: PropTypes.any,
};
export default function TicketTabs({ onTabChange, children }) {
  const navigate = useNavigate();
  const { unreadCount } = useSelector((state) => state.tickets);
  const {
    data: { activeTickets },
  } = useSelector((state) => state.tickets);
  const [searchParams] = useSearchParams();
  const status = searchParams.get('status');
  const handleTabChange = (event, newValue) => {
    if (onTabChange) onTabChange(newValue);
    switch (newValue) {
      case 0:
        navigate(`/dashboard/tickets?status=active`);
        break;
      case 1:
        navigate(
          `/dashboard/tickets?status=complete&start=${new Date(
            new Date().setDate(new Date().getDate() - 29)
          ).toISOString()}&end=${new Date(new Date().getTime() + 24 * 60 * 60 * 1000).toISOString()}`
        );
        break;
      default:
        break;
    }
  };
  const pinnedCount = useMemo(
    () => activeTickets.reduce((count, ticket) => count + (ticket.aboveLine ? 1 : 0), 0),
    [activeTickets]
  );

  const isActive = status !== 'complete';

  return (
    <Box display="flex" alignItems="center" mb={0}>
      <Tabs value={isActive ? 0 : 1} onChange={handleTabChange} sx={{ minHeight: 40 }}>
        <Tab
          sx={{ minHeight: 40, py: 0 }}
          label={
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
              <Typography variant="body2" sx={{ fontWeight: 500, whiteSpace: 'nowrap' }}>
                Open Tickets
              </Typography>

              {unreadCount > 0 && (
                <Tooltip title="Unread tickets">
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                    <EmailIcon sx={{ fontSize: 16 }} />
                    <Typography variant="caption">({fNumber(unreadCount)})</Typography>
                  </Box>
                </Tooltip>
              )}

              {pinnedCount > 0 && (
                <Tooltip title="Pinned tickets">
                  <Box sx={{ display: 'flex', alignItems: 'center', gap: 0.25 }}>
                    <PushPinIcon sx={{ fontSize: 16 }} />
                    <Typography variant="caption">({fNumber(pinnedCount)})</Typography>
                  </Box>
                </Tooltip>
              )}
            </Box>
          }
        />

        <Tab sx={{ minHeight: 40, py: 0 }} label="Completed Tickets" />
      </Tabs>
      {children}
    </Box>
  );
}
